<span
  class="pdf-download-trigger"
  [class.pdf-download-trigger--disabled]="isLoading"
  role="button"
  tabindex="0"
  [attr.title]="tooltip"
  [attr.aria-label]="tooltip"
  (click)="onTrigger($event)"
  (keydown)="onTriggerKeydown($event)"
>
  @if (isLoading) {
    <gc-loading-spinner [pixelSize]="24" />
  } @else {
    <gc-icon [iconName]="'download'" [size]="'medium'" [color]="'primary'" />
  }
</span>
